"use strict"

import React from "react"
import { Button, OverlayTrigger, Popover } from "react-bootstrap"

import { isLTPM } from "../../../../components/shared_components_registration"
import { isHomeDashPlot } from "../../resources/utils"
const registration = {
  download_graph_info_title: (intl) =>
    isLTPM ? intl.formatMessage({ id: "graphing.graphdownloader.title" }) : "Download Graph Information",
  download_graph_image_title: (intl) =>
    isLTPM ? intl.formatMessage({ id: "graphing.graphdownloader.image.title" }) : "Download Graph Image",
  download_graph_data_title: (intl) =>
    isLTPM ? intl.formatMessage({ id: "graphing.graphdownloader.data.title" }) : "Download Graph Data",
  download_graph_comments_title: (intl) =>
    isLTPM ? intl.formatMessage({ id: "graphing.graphdownloader.comments.title" }) : "Download Run Comments",
}

export default function DownloadPopoverMenu({
  placement,
  showGraphModal,
  graph_name,
  data_name,
  comment_name,
  actions = [],
  op,
  popover,
  loading = [],
  intl,
}) {
  const { special, category } = op

  const handleClick = (e, modal_name) => {
    e.preventDefault()
    $("#graph_downloader").hide()
    showGraphModal(modal_name)
  }

  const MultiPlotSpan = () => (
    <>
      {special === "multi" && !isHomeDashPlot(op) && (
        <span
          className={"fa fa-random"}
          aria-hidden={"true"}
          style={{
            fontSize: "70%",
            top: "1px",
            right: "2px",
            position: "absolute",
            color: "var(--lanzalake-grey-mid)",
          }}
        />
      )}
    </>
  )

  const button_bar = (
    <>
      {graph_name && (
        <Button
          variant={"outline-primary"}
          onClick={(e) => handleClick(e, graph_name)}
          disabled={special === "heatmap" || loading.length > 0}
          title={registration["download_graph_image_title"](intl)}
        >
          <span className={"fa fa-picture-o"} aria-hidden={"true"} />
          <MultiPlotSpan />
        </Button>
      )}
      {data_name && (
        <Button
          variant={"outline-primary"}
          onClick={(e) => handleClick(e, data_name)}
          disabled={loading.length > 0}
          title={registration["download_graph_data_title"](intl)}
        >
          <span className={"fa fa-list"} aria-hidden={"true"} />
          <MultiPlotSpan />
        </Button>
      )}
      {comment_name &&
        (!special ||
          ["obs-vs-obs", "multi", "microbial-community"].includes(special) ||
          ["DNAseq", "RNAseq"].includes(category)) && (
          <Button
            variant={"outline-primary"}
            onClick={(e) => handleClick(e, comment_name)}
            disabled={!actions || actions.length === 0 || loading.length > 0}
            title={registration["download_graph_comments_title"](intl)}
          >
            <span className={"fa fa-pencil"} aria-hidden={"true"} />
            <MultiPlotSpan />
          </Button>
        )}
    </>
  )

  const overlay = (
    <Popover id={"graph_downloader"} title={registration["download_graph_info_title"](intl)}>
      <Popover.Header as={"h3"}>{registration["download_graph_info_title"](intl)}</Popover.Header>
      <Popover.Body style={{ textAlign: "center" }}>{button_bar}</Popover.Body>
    </Popover>
  )

  return (
    <>
      {popover ? (
        <OverlayTrigger trigger={"click"} placement={placement} rootClose overlay={overlay}>
          <Button
            variant={"outline-primary"}
            disabled={loading.length > 0}
            title={registration["download_graph_info_title"](intl)}
          >
            <span className={"fa fa-cloud-download"} aria-hidden={"true"} />
          </Button>
        </OverlayTrigger>
      ) : (
        <>{button_bar}</>
      )}
    </>
  )
}
